<ng-container>
    <lib-data-capture-heading id="DatePickerHeading" [QnDescription]="qnData.qDescription" [QnSubDescription]="qnData.qSubDescription">
    </lib-data-capture-heading>
    <lib-date-picker id="dtDatePicker" [field]="field" [form]="dateForm" [offsetValue]="offsetValue"></lib-date-picker>
    <div class="next-btn-container" [class.disable-container]="!dateForm.valid">
        <lib-primary-button id="btnNExt" [text]="nextBtn" (clicked)="submitDate()" [disabled]="!dateForm.valid">
        </lib-primary-button>
    </div>
</ng-container>